import { render, staticRenderFns } from "./AddRecordModal.vue?vue&type=template&id=3c05577a"
import script from "./AddRecordModal.vue?vue&type=script&lang=js"
export * from "./AddRecordModal.vue?vue&type=script&lang=js"
import style0 from "./AddRecordModal.vue?vue&type=style&index=0&id=3c05577a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports